<template>
    <div class="container">
        <div class="title notice-box-title" v-if="notice">
            公告
            <div class="item-notice">
                <div class="file-title" v-if="notice.filename" v-on:click="downNoticeFile">
                    <i class="file-icon" v-bind:class="notice.type"></i>
                    {{notice.filename}}
                    <span>({{notice.size}})</span>
                </div>
                <div class="downLoad">
                    <div class="right-btn" v-if="notice.filename">
                        <span v-on:click="downNoticeFile">
                            下载
                            <img src="../../images/tips-blue.png" />
                            <label class="file-down-desc">此处下载的是公告附件</label>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="block block-shadow" v-if="notice">
            <p class="notice-title ellipsis">
                {{notice.title}}
                <span
                    class="extend-notice zk rt"
                    @click="isExtend=1"
                    v-show="isExtend==0"
                >展开</span>
                <span class="extend-notice sq rt" @click="isExtend=0" v-show="isExtend==1">收起</span>
            </p>
            <div class="notice-desp">
                <p v-show="isExtend==1" v-html="notice.content"></p>
            </div>
            <div
                v-if="isExtend==1 && notice.createTime"
                class="notice-time"
            >{{publicFunction.dateFormatByTTime(notice.createTime,'yyyy-MM-dd hh:mm')}}</div>
            <p v-show="isExtend==0" class="notice-sq ellipsis">{{notice.sqcontent}}</p>
        </div>

        <p class="title">实时资讯</p>
        <div class="block">
            <div class="five-left area-hot-block">
                <p class="sub-title">区域热点</p>
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div
                            class="swiper-slide"
                            v-for="(item,index) in areaHotDatas"
                            v-if="index%2==0"
                        >
                            <div class="area-hot border-bottom">
                                <span class="hot-val">热度值：{{item.heat}}</span>
                                <p class="news-title ellipsis">
                                    <a target="_blank" :href="item.url">{{item.title}}</a>
                                </p>
                                <p class="ellipsis-two news-content">
                                    <a target="_blank" :href="item.url">{{item.summary}}</a>
                                </p>
                            </div>
                            <div class="area-hot" v-if="areaHotDatas[index+1]!=null">
                                <span class="hot-val">热度值：{{areaHotDatas[index+1].heat}}</span>
                                <p class="news-title ellipsis">
                                    <a
                                        target="_blank"
                                        :href="areaHotDatas[index+1].url"
                                    >{{areaHotDatas[index+1].title}}</a>
                                </p>
                                <p class="ellipsis-two news-content">
                                    <a
                                        target="_blank"
                                        :href="areaHotDatas[index+1].url"
                                    >{{areaHotDatas[index+1].summary}}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="five-right new-news">
                <p class="sub-title">突发事件</p>
                <div class="table-title border-bottom">
                    <div class="col1 lt">标题</div>
                    <div class="col2 lt">日期</div>
                    <div class="col3 lt">地域</div>
                </div>
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <!-- <div class="swiper-slide" v-for="(item,index) in areaNewDatas" v-if="index%6==0"> -->
                        <div
                            class="swiper-slide"
                            v-for="(item,index) in areaNewDatas"
                            v-if="index%6==0"
                        >
                            <div class="border-bottom new-news-item">
                                <div class="news-box">
                                    <div class="table-title">
                                        <div class="col1 col-title lt ellipsis">
                                            <a target="_blank" :href="item.url">{{item.title}}</a>
                                        </div>
                                        <div class="col2 col-date lt">
                                            <a
                                                target="_blank"
                                                :href="item.url"
                                            >{{publicFunction.dateFormatByTTime(item.pubtime,'yyyy-MM-dd hh:mm')}}</a>
                                        </div>
                                        <div class="col3 col-area lt">
                                            <a target="_blank" :href="item.url">{{item.areaName}}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="border-bottom new-news-item" v-if="areaNewDatas[index+1]">
                                <div class="news-box">
                                    <div class="table-title">
                                        <div class="col1 col-title lt ellipsis">
                                            <a
                                                target="_blank"
                                                :href="areaNewDatas[index+1].url"
                                            >{{areaNewDatas[index+1].title}}</a>
                                        </div>
                                        <div class="col2 col-date lt">
                                            <a
                                                target="_blank"
                                                :href="areaNewDatas[index+1].url"
                                            >{{publicFunction.dateFormatByTTime(areaNewDatas[index+1].pubtime,'yyyy-MM-dd hh:mm')}}</a>
                                        </div>
                                        <div class="col3 col-area lt">
                                            <a
                                                target="_blank"
                                                :href="areaNewDatas[index+1].url"
                                            >{{areaNewDatas[index+1].areaName}}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="border-bottom new-news-item" v-if="areaNewDatas[index+2]">
                                <div class="news-box">
                                    <div class="table-title">
                                        <div class="col1 col-title lt ellipsis">
                                            <a
                                                target="_blank"
                                                :href="areaNewDatas[index+2].url"
                                            >{{areaNewDatas[index+2].title}}</a>
                                        </div>
                                        <div class="col2 col-date lt">
                                            <a
                                                target="_blank"
                                                :href="areaNewDatas[index+2].url"
                                            >{{publicFunction.dateFormatByTTime(areaNewDatas[index+2].pubtime,'yyyy-MM-dd hh:mm')}}</a>
                                        </div>
                                        <div class="col3 col-area lt">
                                            <a
                                                target="_blank"
                                                :href="areaNewDatas[index+2].url"
                                            >{{areaNewDatas[index+2].areaName}}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="border-bottom new-news-item" v-if="areaNewDatas[index+3]">
                                <div class="news-box">
                                    <div class="table-title">
                                        <div class="col1 col-title lt ellipsis">
                                            <a
                                                target="_blank"
                                                :href="areaNewDatas[index+3].url"
                                            >{{areaNewDatas[index+3].title}}</a>
                                        </div>
                                        <div class="col2 col-date lt">
                                            <a
                                                target="_blank"
                                                :href="areaNewDatas[index+3].url"
                                            >{{publicFunction.dateFormatByTTime(areaNewDatas[index+3].pubtime,'yyyy-MM-dd hh:mm')}}</a>
                                        </div>
                                        <div class="col3 col-area lt">
                                            <a
                                                target="_blank"
                                                :href="areaNewDatas[index+3].url"
                                            >{{areaNewDatas[index+3].areaName}}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="border-bottom new-news-item" v-if="areaNewDatas[index+4]">
                                <div class="news-box">
                                    <div class="table-title">
                                        <div class="col1 col-title lt ellipsis">
                                            <a
                                                target="_blank"
                                                :href="areaNewDatas[index+4].url"
                                            >{{areaNewDatas[index+4].title}}</a>
                                        </div>
                                        <div class="col2 col-date lt">
                                            <a
                                                target="_blank"
                                                :href="areaNewDatas[index+4].url"
                                            >{{publicFunction.dateFormatByTTime(areaNewDatas[index+4].pubtime,'yyyy-MM-dd hh:mm')}}</a>
                                        </div>
                                        <div class="col3 col-area lt">
                                            <a
                                                target="_blank"
                                                :href="areaNewDatas[index+4].url"
                                            >{{areaNewDatas[index+4].areaName}}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <p class="title">
            我的任务
            <span class="taskNum">({{taskCount}})</span>
            <span @click="toMore" class="more">查看更多</span>
        </p>
        <div class="mytask">
            <div class="taskblock" v-for="(item,index) in tasks" v-on:click="toTaskDetail(item)">
                <p class="task-lineheight ellipsis-two">
                    <span class="task-state task-state-prepare" v-if="item.state=='ready'">未开始</span>
                    <span class="task-state task-state-doing" v-if="item.state=='ing'">执行中</span>
                    <span class="task-state task-state-done" v-if="item.state=='done'">已完成</span>
                    <span class="task-title">{{item.name}}</span>
                </p>
                <p class="task-p">
                    <span class="task-name">任务等级：</span>
                    <span class="task-value" v-if="item.level==1">高</span>
                    <span class="task-value" v-if="item.level==2">中</span>
                    <span class="task-value" v-if="item.level==3">低</span>
                </p>
                <p class="task-p">
                    <span class="task-name">任务类型：</span>
                    <span class="task-value">{{item.type==1?'报道任务':item.type==2?'推稿任务':'反馈任务'}}</span>
                </p>
                <p class="task-p">
                    <span class="task-name">任务时间：</span>
                    <span class="task-value">{{item.startTime}}</span>
                    <span class="task-sperate">至</span>
                    <span>{{item.endTime}}</span>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import Swiper from 'swiper';
export default {
    data() {
        return {
            userLevel: 1,
            notice: {},
            areaHotDatas: [],
            areaNewDatas: [],
            tasks: [],
            taskCount: 0,
            isExtend: 0
        };
    },
    created() {
        this.loadUserLevel();
        this.loadNotice();
        this.loadTask();
    },
    mounted() {
        this.initNewNewsData();
        this.initAreaHotData();
    },
    methods: {
        ...mapActions([
            'propagateOvLatestNotice',
            'propagateOvNoticeDownload',
            'propagateOvPublicityPage',
            'getCurrentHotNews',
            'propagateEmergencyNews',
            'propagateOvUserLevel'
        ]),
        loadUserLevel() {
            this.propagateOvUserLevel().then(rtn => {
                this.userLevel = rtn.userLevel;
            });
        },
        downNoticeFile() {
            let downToken = sessionStorage.getItem('token');
            let urlPre = process.env.VUE_APP_SERVER_URL;
            let isSafari = this.publicFunction.judgeSafari();
            window.open(`${urlPre}/noticeManager/noticeDownload?id=${this.notice.id}&token=${downToken}&isSafari=${isSafari}`);
        },
        toMore() {
            if (this.userLevel == 1) {
                this.$router.push('/superiorTask');
            } else {
                this.$router.push('/subordinateTask/propagateJob');
            }
        },
        toTaskDetail(item) {
            if (item.result == 1) {
                let routeUrl = this.$router.resolve({
                    path: '/taskDetail',
                    query: {
                        id: item.id
                    }
                });
                window.open(routeUrl.href, '_blank');
            } else {
                this.$router.push(`/superiorTask/lookTask?id=${item.id}`);
            }
        },
        loadNotice() {
            this.propagateOvLatestNotice().then(rtn => {
                this.notice = rtn.data;
                if (this.notice) {
                    this.notice.sqcontent = this.notice.content.replace(/\n/gm, '');
                    this.notice.content = this.notice.content.replace(/\n/gm, '<br/>');
                }
            });
        },
        loadTask() {
            this.propagateOvPublicityPage({ size: 9, number: 0 }).then(rtn => {
                this.tasks = rtn.content;
                this.taskCount = rtn.totalElements;
            });
        },
        //突发事件
        initNewNewsData() {
            //初始化最新文章swiper
            this.propagateEmergencyNews({ size: 30, number: 0 }).then(rtn => {
                this.areaNewDatas = rtn;
                this.$nextTick(function() {
                    setTimeout(function() {
                        var mySwiper = new Swiper('.new-news .swiper-container', {
                            autoplay: 5000, //可选选项，自动滑动
                            loop: true,
                            speed: 1500,
                            direction: 'vertical'
                        });
                    }, 2000);
                });
            });
        },
        //区域热点
        initAreaHotData() {
            //初始化区域热点swiper
            this.getCurrentHotNews({ size: 10, number: 0 }).then(rtn => {
                this.areaHotDatas = rtn.content;
                this.$nextTick(function() {
                    new Swiper('.area-hot-block .swiper-container', {
                        autoplay: 5000, //可选选项，自动滑动
                        loop: true,
                        speed: 800,
                        direction: 'vertical'
                    });
                });
            });
        }
    }
};
</script>
<style lang="scss" scoped type="text/css">
/*区域热点  开始*/
.area-hot-block .swiper-container {
    height: 230px;
}
.area-hot-block {
    overflow: hidden;
    height: 281px;
}
.area-hot-block .news-title {
    margin-right: 150px;
}
.area-hot-block .hot-val {
    padding-left: 20px;
    border-left: solid 1px #ccc;
    float: right;
    color: #cc6666;
}
.area-hot {
    padding-bottom: 20px;
}
/*区域热点  结束*/

.block-shadow {
    box-shadow: 0px 0px 8px 0px rgba(102, 102, 102, 0.3);
}
.notice-box-title {
    display: flex;
}
.extend-notice.sq:after {
    margin-top: -5px;
    background-image: url(../../images/extend-sq.png);
}
.extend-notice.zk:after {
    background-image: url(../../images/extend-zk.png);
}
.extend-notice:after {
    content: '';
    display: inline-block;
    vertical-align: middle;
    height: 6px;
    width: 16px;
    background-size: 100% 100%;
}
.notice-sq {
    padding-bottom: 20px;
}
.extend-notice {
    font-size: 14px;
    cursor: pointer;
    font-weight: normal;
    margin-right: -100px;
    color: #026afd;
}
.notice-title {
    color: #333;
    font-size: 16px;
    padding: 20px 100px 20px 0;
    font-weight: bold;
}
.notice-desp {
    padding-left: 20px;
}
.notice-desp p {
    color: #333;
    font-size: 14px;
    padding-top: 20px;
}
.notice-time {
    color: #999999;
    font-size: 16px;
    text-align: right;
    padding: 20px 0;
}

.item-notice {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
}
.item-notice .file-title {
    cursor: pointer;
    margin-left: 30px;
    color: #406cb4;
    font-weight: normal;
}
.item-notice span {
    color: #999;
}
.item-notice .file-icon {
    background-size: 100%;
    display: inline-block;
    width: 18px;
    height: 18px;
    vertical-align: -4px;
}
.item-notice .jpg,
.item-notice .png,
.item-notice .jpeg {
    background-image: url(../../images/img.png);
}
.item-notice .zip {
    background-image: url(../../images/zip.png);
}
.item-notice .rar {
    background-image: url(../../images/rar.png);
}
.item-notice .doc,
.item-notice .docx {
    background-image: url(../../images/word.png);
}
.item-notice .xls,
.item-notice .xlsx {
    background-image: url(../../images/excel.png);
}
.item-notice .pdf {
    background-image: url(../../images/pdf.png);
}
.item-notice .right-btn .file-down-desc {
    display: none;
    position: absolute;
    top: 11px;
    right: 2px;
    background-color: #fff;
    border: solid 1px #f0f0f0;
    width: 150px;
}
.item-notice .right-btn img {
    position: absolute;
    top: -11px;
    right: -9px;
    height: 25px;
    width: 25px;
}
.item-notice .right-btn img:hover + .file-down-desc {
    display: inline-block;
}
.item-notice .right-btn span {
    font-weight: normal;
    display: inline-block;
    position: relative;
    width: 80px;
    height: 26px;
    line-height: 26px;
    margin-left: 8px;
    background: #456288;
    cursor: pointer;
    margin-right: 30px;
    margin-left: 50px;
    color: #fff;
    font-size: 14px;
    text-align: center;
}

.taskNum {
    font-size: 14px;
    color: #456288;
    font-weight: normal;
}
.more {
    cursor: pointer;
    float: right;
    text-decoration: underline;
    font-size: 14px;
    color: #456288;
    font-weight: normal;
    margin-right: 30px;
}
.mytask {
    width: 100%;
    overflow: hidden;
    margin-top: 10px;
    box-sizing: border-box;
}
.taskblock {
    cursor: pointer;
    width: 32%;
    float: left;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 8px 0px rgba(102, 102, 102, 0.1);
    padding: 35px 30px;
    margin-right: 20px;
    margin-bottom: 20px;
    box-sizing: border-box;
}
.taskblock:nth-child(3n) {
    margin-right: 0px;
}
.task-state {
    padding: 5px 6px;
    color: #fff;
    font-size: 16px;
}
.task-state-prepare {
    background: rgba(205, 205, 205, 1);
}
.task-state-doing {
    background: rgba(2, 106, 253, 1);
}
.task-state-done {
    background: rgba(34, 176, 9, 1);
}
.task-lineheight {
    line-height: 24px;
}
.task-title {
    font-size: 16px;
    padding-left: 10px;
    color: #333;
}
.task-name {
    color: #999;
}
.task-sperate {
    color: #999;
    margin: 0px 5px;
}
.task-p {
    margin-top: 17px;
}
.table-title {
    width: 100%;
    overflow: hidden;
    height: 35px;
    line-height: 35px;
}
.col1 {
    width: 50%;
}
.col2 {
    box-sizing: border-box;
    padding-left: 10px;
    width: 30%;
}
.col3 {
    width: 20%;
}
.col-area a {
    color: #999;
}
.col-date a {
    color: #999;
    cursor: pointer;
}
.col-title a {
    color: #666;
}

.no-data {
    text-align: center;
    color: #999;
    margin-top: 30px;
}
.new-news {
    overflow: hidden;
}
.news-box .dot {
    display: inline-block;
    background: #f0f0f0;
    vertical-align: middle;
    width: 5px;
    height: 5px;
    border-radius: 50%;
}
.new-news .new-news-item {
    position: relative;
    overflow: hidden;
}
.new-news .swiper-container {
    height: 230px;
}
.new-news .left-img p {
    color: #999;
    text-align: center;
}
.new-news .left-img {
    display: inline-block;
    position: absolute;
    width: 60px;
    top: 50%;
    transform: translateY(-50%);
}
.new-news .left-img img {
    border-radius: 50%;
    height: 60px;
    width: 60px;
}
.news-box {
    margin-left: 0px;
}
.new-news .news-assist {
    margin: 7px 0;
}
.new-news .news-title {
    margin: 8px 0;
}
</style>
